import BaseComponent from '../../base/base_component';
import DOM from '../../utils/dom';
import _ from '../../utils/underscore';
import Event from "../../utils/event";
import {SYSTEM_EVENTS} from "../../events/events";
import {BaseComponentParams} from "../../base/base_component_interface";
import Device from "../../utils/device";

const templateView = require('./view/view.html');

interface NetPositionControllerParams extends BaseComponentParams{
    gameType?: number;
}

export default class NetPositionController extends BaseComponent {
    static CLASS = 'NetPositionController';

    protected _selector = 'cgp-net-position-component';

    private params: NetPositionControllerParams;

    private receivedFireBaseValueWithoutRoundEndCounter = 0;
    private gameRoundEndEventExistOnGame = false;
    private queueLastFireBaseRoundValue = null;
    private queueLastRoundEndReceive = false;

    init(params) {
        params = params || {};
        super.init(params);

        this._bakeHTML();

        this.params = params;

        this._setAmount(0);
        this._subscribe();
        this._resetFirebaseGameTypeForSessionAmount();
    }

    _bakeHTML(){
        this.setHTML(this.bake(templateView));

        if (Device.isMobile()) {
            this.addClass('cgp-themes-small-secondary-grayed-out-text');
        } else {
            this.addClass('cgp-themes-grayed-out-text');
        }
    }

    _setAmount(value) {

        if (_.isNullOrUndefined(value)) {
            value = 0;
        }

        DOM.text(this.querySelector(`.${this._selector}-value`), this.serviceFactory.currencyService().formatMoney(value));
        this.logger.debug('Update Strip and reset values', value);
        this._resetQueueValues();


        //Report strip update also to Kibana for better monitoring (only for vip users -avoiding too much reporting)
        const accountData = this.serviceFactory.userService().getAccountData();
        if (accountData && accountData.IsVip) {
            this._sendElasticEvent("Net Position Strip update", "Net Position Strip update", value);
        }

    }

    _receivedNetPosition(netPosition = {}) {
        if(netPosition.hasOwnProperty(this.params?.gameType)){
            const receivedNetPositionValue = netPosition[this.params.gameType];

            if(this.gameRoundEndEventExistOnGame === true){

                if(this.queueLastRoundEndReceive){
                    this.logger.debug('NP Value Receive, Round end  value already in queue');
                    this._setAmount(receivedNetPositionValue);
                }else{
                    this.queueLastFireBaseRoundValue = receivedNetPositionValue;
                    this.logger.debug('queueLastFireBaseRoundValue enter to queue', this.queueLastFireBaseRoundValue);
                }

            }else{
                this.receivedFireBaseValueWithoutRoundEndCounter++;
                if(this.receivedFireBaseValueWithoutRoundEndCounter === 3){
                    this._sendElasticEvent("missing_round_end_event", "Missing Round End Event", this.params.gameType);
                }

                this._setAmount(receivedNetPositionValue);
            }
        }
    }

    _subscribe(){
        Event.on(SYSTEM_EVENTS.NET_POSITION_VALUE_UPDATE, this._receivedNetPosition.bind(this));
    }

    _resetFirebaseGameTypeForSessionAmount(){
        this._resetQueueValues();

        this.gameRoundEndEventExistOnGame = false;
        this.receivedFireBaseValueWithoutRoundEndCounter = 0;

        this.params?.gameType && this.serviceFactory.netPositionService().initializeNetPositionOnGameType(this.params.gameType);
    }

    _resetQueueValues(){
        this.queueLastFireBaseRoundValue = undefined;
        this.queueLastRoundEndReceive = false;
        this.logger.debug('Reset Queue Values');
    }

    _sendElasticEvent(action, label, value){
        const data = {
            CGPEventCategory: "NetPosition",
            CGPEventAction: action,
            CGPEventLabel: label,
            CGPEventValue: value
        };
        this.serviceFactory.structuredLoggingService().getLogger(data).info();
    }

    onGameRoundEnd(){
        this.gameRoundEndEventExistOnGame = true;

        if(this.queueLastFireBaseRoundValue){
            this.logger.debug('RoundEnd Received, NP value already in queue', this.queueLastFireBaseRoundValue);
            this._setAmount(this.queueLastFireBaseRoundValue);
        }else{
            this.logger.debug('RoundEnd Received, enter to queue');
            this.queueLastRoundEndReceive = true;
        }
    }

}